var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1219_138)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4592 26.1188C43.2682 26.9605 39.5664 31.922 40.1039 37.3171C40.6338 42.6363 44.8409 46.57 50 46.57C54.474 46.57 58.2714 43.6338 59.5478 39.1875C60.55 35.6964 59.6471 31.8561 57.1961 29.185C54.9936 26.7849 51.6303 25.6045 48.4592 26.1188ZM45.1363 47.8449C42.5103 48.0469 39.996 48.9847 37.903 50.5429C35.1716 52.5764 33.2277 55.5194 32.4215 58.8421C32.0302 60.4549 32 60.8993 32 65.0527V68.9675L32.2034 69.2786C32.3154 69.4497 32.5371 69.682 32.6962 69.7949L32.9855 70H50H67.0145L67.3038 69.7949C67.4629 69.682 67.6846 69.4497 67.7966 69.2786L68 68.9675V65.0527C68 60.8993 67.9698 60.4549 67.5785 58.8421C66.3705 53.8636 62.6145 49.831 57.8568 48.4046C56.0384 47.8593 55.7056 47.8315 50.6651 47.8017C48.1273 47.7867 45.6393 47.8062 45.1363 47.8449Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1219_138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 62.5,
    r: 12.5,
    fill: "url(#paint1_linear_1219_138)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 62.5,
    r: 12.5,
    stroke: "url(#paint2_linear_1219_138)",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6834 63.3128L55.9017 60.5754L54 62.3352L58.6834 67L67 58.8994L65.1266 57L58.6834 63.3128Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1219_138",
    x: 45.85,
    y: 47.85,
    width: 29.3,
    height: 29.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1219_138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1219_138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_138",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_138",
    x1: 50.6753,
    y1: 52.3065,
    x2: 77.6595,
    y2: 66.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1219_138",
    x1: 62.5833,
    y1: 54.1667,
    x2: 71.9583,
    y2: 76.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.a43cdff04b2ca163f27d85030f00d498.svg";
export { ForwardRef as ReactComponent };